/*
**  rui-popup-notification.js
**
**  rui-popup-notification component
*/
import { LitElement, html } from 'lit-element';
import { ruiShowPopupNotification, ruiHidePopupNotification } from '../../js/rui-popup-notifications.js';
export class RuiPopupNotification extends LitElement {
    static get is() {
        return 'rui-popup-notification';
    }
    static get properties() {
        return {
            type: { type: String },
            text: { type: String },
            closeButtonText: { type: String },
            autoDismiss: { type: Object },
            showNotification: { type: Object }
        };
    }
    constructor() {
        super();
        this.type = 'information';
        this.text = '';
        this.closeButtonText = '';
        this.autoDismiss = true;
        this._showNotification = false;
        this.notificationHandle = null;
    }
    // Custom setter for showNotification property
    set showNotification(newValue) {
        if (this._showNotification !== newValue) {
            this._showNotification = newValue;
            // Fire show notification change event
            Promise.resolve().then(() => {
                let showNotificationChangeEvent = new CustomEvent('rui-popup-notification-show-notification-change', {
                    detail: this._showNotification,
                    bubbles: true,
                    composed: true
                });
                this.dispatchEvent(showNotificationChangeEvent);
            });
            this.requestUpdate();
            if (this._showNotification) {
                // Show the popup notification
                this.showPopupNotification();
                // Reset the boolean trigger property
                Promise.resolve().then(() => {
                    this.showNotification = false;
                });
            }
        }
    }
    // Custom getter for showNotification property
    get showNotification() {
        return this._showNotification;
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('rui-popup-notification-internal-click', (e) => this.popupNotificationClick(e));
        window.addEventListener('rui-popup-notification-internal-close-button-click', (e) => this.popupNotificationCloseButtonClick(e));
        window.addEventListener('rui-popup-notification-internal-close', (e) => this.popupNotificationClose(e));
    }
    disconnectedCallback() {
        window.removeEventListener('rui-popup-notification-internal-click', (e) => this.popupNotificationClick(e));
        window.removeEventListener('rui-popup-notification-internal-close-button-click', (e) => this.popupNotificationCloseButtonClick(e));
        window.removeEventListener('rui-popup-notification-internal-close', (e) => this.popupNotificationClose(e));
        super.disconnectedCallback();
    }
    popupNotificationClick(e) {
        if (this.notificationHandle === e.detail) {
            e.preventDefault();
            e.stopPropagation();
            // Fire click event
            let clickEvent = new CustomEvent('rui-click', {
                detail: {},
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(clickEvent);
        }
    }
    popupNotificationCloseButtonClick(e) {
        if (this.notificationHandle === e.detail) {
            e.preventDefault();
            e.stopPropagation();
            // Fire click event
            let closeButtonClickEvent = new CustomEvent('rui-close-button-click', {
                detail: {},
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(closeButtonClickEvent);
        }
    }
    popupNotificationClose(e) {
        if (this.notificationHandle === e.detail) {
            e.preventDefault();
            e.stopPropagation();
            // Forget this popup notification
            this.notificationHandle = null;
        }
    }
    showPopupNotification() {
        this.notificationHandle = ruiShowPopupNotification({
            type: this.type,
            text: this.text,
            closeButtonText: this.closeButtonText,
            autoDismiss: this.autoDismiss
        });
    }
    hidePopupNotification() {
        if (this.notificationHandle) {
            ruiHidePopupNotification(this.notificationHandle);
        }
    }
    render() {
        // This component's visuals are added to the DOM using Javascript, so no template or css is defined here
        return html ``;
    }
}
customElements.get(RuiPopupNotification.is) || customElements.define(RuiPopupNotification.is, RuiPopupNotification);
